import employeesActions from '../actionTypes/employeesActions';

const initialState = {
  isLoading: true,
  data: { users: [] },
  per: 10,
};

const convertEmployeeData = ({ data }) => {
  return data.users.map((emp) => {
    return { ...emp, profile: { employee_id: emp.employee_id } };
  });
};

export default (state = initialState, action) => {
  switch (action.type) {
    case employeesActions.getEmployeesList:
      return {
        ...state,
        ...action.payload,
        isLoading: true,
      };
    case employeesActions.getEmployeesListSuccess:
    case employeesActions.getEmployeesListFailed:
      return {
        ...state,
        ...action.payload,
        data: {
          ...action.payload.data,
          users: convertEmployeeData(action.payload),
        },
        isLoading: false,
      };
    case employeesActions.deleteRestaurant:
    case employeesActions.deleteRestaurantSuccess:
    case employeesActions.deleteRestaurantFailed:
    default:
      return state;
  }
};
